import { Box, CssBaseline, Grid, Paper } from "@mui/material";
import React from "react";
import coverPhoto from "../assets/login_cover_photo.png";

interface CommonNonAuthenticatedPageLayoutProps {
  children: React.ReactNode;
}

const CommonNonAuthenticatedPageLayout = ({ children }: CommonNonAuthenticatedPageLayoutProps) => {
  return (
    <Grid container component="main">
      <CssBaseline />
      <Grid
        item
        xs={false}
        sm={4}
        md={7}
        sx={{
          backgroundImage: `url(${coverPhoto})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) => (t.palette.mode === "light" ? t.palette.grey[50] : t.palette.grey[900]),
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          minHeight: "100vh",
        }}
      />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Box
          sx={{
            my: 8,
            mx: 4,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box sx={{ width: "80%", display: "flex", flexDirection: "column", alignItems: "center" }}>{children}</Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CommonNonAuthenticatedPageLayout;
